import vue from 'vue'
import {getDocumentPage, editDocumentPage, queryDocument} from "../../../services/file/filePage"

const state = {
  dataPages: [],
  detailsData: [],
  editVisible: false,
}

const getters = {
  dataPages: () => state.dataPages,
  detailsData: () => state.detailsData,
  editVisible: () => state.editVisible,
}

const actions = {
  //页面文档列表
  getDocumentPage({commit, dispatch}, objc) {
    getDocumentPage(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'dataPages', update: res.data});
        commit('updateState', {state: 'total', update: res.data.total});
      }
    })
  },

  //根据ID查询
  queryDocument({commit, dispatch}, objc) {
    queryDocument(objc).then((res) => {
      if (res.code === 0 && res.data) {
        commit('updateState', {state: 'detailsData', update: res.data});
      }
    })
  },

  //编辑文档链接
  editDocumentPage({commit, dispatch}, objc) {
    editDocumentPage(objc).then((res) => {
      if (res.code === 0) {
        commit('updateState', {state: 'editVisible', update: false});
        dispatch('getDocumentPage');
      }
    })
  }
}

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/file/modules/filePage.js